<template>
    <router-link :to="link" class="news-card d_f jc_sb">
        <img :src="img" alt="">
        <div class="news-span d_f d_f_c jc_sb">
            <p class='M_x'>
                {{title}}
            </p>
            <span class="M_sm">
                {{date}}
            </span>
        </div>
    </router-link>
</template>


<script>
export default {
    
    props : {
        title : String,
        date : String ,
        img : String ,
        link : String
    }



}
</script>


<style lang="scss" scoped>

    .news-card{
        margin-bottom: 50px;
        img{
            width: 128px;
            height: 128px;
        }
        .news-span{
            flex: 1;
            margin-left: 25px;
            p{
                max-height: 72px;
                font-size: 19px;
                margin-bottom: 0 !important;
                color: #202737;
            }
            span{
                color: #ccc;
                font-size: 13px;
            }
        }
    }



</style>